import { Input,Component, Sanitizer, OnInit } from '@angular/core';
import { AlertController,ModalController, ToastController } from '@ionic/angular/standalone';
import { IonApp,IonSelect, IonButtons,IonInput, IonItemDivider,IonHeader,IonToolbar, IonTitle, IonSelectOption, IonSplitPane, IonButton,IonMenu, IonContent, IonList, IonListHeader, IonNote, IonMenuToggle, IonItem, IonIcon, IonLabel, IonRouterOutlet, IonRouterLink, IonMenuButton } from '@ionic/angular/standalone';
import { FormsModule } from '@angular/forms';
import { KeyValuePipe } from '@angular/common'; 
import { CommonModule } from '@angular/common';
import {Parser} from '../bhatkhande';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import  {TaalType, Marker ,Vibhag,TempoGenre
} from '../interfaceTypes';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MarkerComp } from './MarkerComp';

import { register  } from 'swiper/element/bundle';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
register();

@Component({
  selector: 'app-taal',
  templateUrl: './taal.page.html',
  styleUrls: ['./taal.page.scss'],
 
  imports: [CommonModule, IonToolbar,IonButton,IonButtons,IonHeader,IonItemDivider,IonListHeader, IonTitle,IonButton, IonSelectOption,IonApp, IonSplitPane, IonMenu, IonContent, IonList, IonListHeader, IonNote, IonMenuToggle, IonItem, IonIcon, IonLabel, IonRouterLink, IonRouterOutlet, IonMenuButton,
    FormsModule,IonInput
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
 
})
export class TaalPage implements OnInit {
  taals: TaalType[] = [];
  newTaal: TaalType = {
    name: '',
    numberOfBeats: 0,
    numberOfVibhag: 0,
    vibhags: [],
    tempoGenre: TempoGenre.Madhyalaya
  };
  searchTerm: string = '';
  vibhagLabel: string = '';
  vibhagStartBeat: number = 0;
  vibhagDuration: number = 0;
  editIndex:number|null=null;
  markers:Marker[]|null=[];
  constructor(
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private modalController:ModalController,
    private parser:Parser,
    private sanitizer:DomSanitizer
  ) {
    this.loadTaals();
  }


swiperConfig  = {
  // Disable touch/swipe interaction
  allowTouchMove: false, 
  // Enable navigation buttons
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // Other Swiper options...
};
ngOnInit()
{


}
  resetForm() {
    this.newTaal = {
      name: '',
      numberOfBeats: 0,
      numberOfVibhag: 0,
      vibhags: [],
      tempoGenre: TempoGenre.Madhyalaya
    };
  }

  async presentToast(message: string) {
    const toast = await this.toastCtrl.create({ message, duration: 2000 });
    toast.present();
  }

  get TempoGenre
  ()
  {
    let genre = Object.values(TempoGenre);
    return genre;
  }

  loadVibhagForEdit(index: number) {
    const v = this.newTaal.vibhags[index];
    this.vibhagLabel = v.label;
    this.vibhagStartBeat = v.startBeat;
    this.vibhagDuration = v.durationInBeats;
    this.markers=v.markers;
    this.editIndex = index;
  }
  
  addVibhag() {
    const label = this.vibhagLabel?.trim();
    const start = parseInt(this.vibhagStartBeat.toString());
    const duration = parseInt(this.vibhagDuration.toString());
  
    // Validate inputs
    if (!label) {
      this.presentToast('Vibhag label cannot be blank');
      return;
    }
  
    if (start <= 0 || duration <= 0 || !Number.isInteger(start) || !Number.isInteger(duration)) {
      this.presentToast('Start and Duration must be positive integers');
      return;
    }
  
    const newRangeStart = start;
    const newRangeEnd = start + duration - 1;
  
    // Check for overlap
    const overlaps = this.newTaal.vibhags.some(v => {
      const existingStart = v.startBeat;
      const existingEnd = v.startBeat + v.durationInBeats - 1;
      return !(newRangeEnd < existingStart || newRangeStart > existingEnd);
    });
  
    if (overlaps) {
      this.presentToast('Overlap with existing vibhag');
      return;
    }
  
    if (newRangeEnd > this.newTaal.numberOfBeats) {
      this.presentToast('Vibhag exceeds total Taal beats');
      return;
    }
  
    const vibhag: Vibhag = {
      label,
      serialNo: this.newTaal.vibhags.length + 1,
      startBeat: start,
      durationInBeats: duration,
      markers: Array(duration).fill(Marker.None)
    };
  
    this.newTaal.vibhags.push(vibhag);
    this.newTaal.numberOfVibhag = this.newTaal.vibhags.length;
  
    this.vibhagLabel="Part "+this.newTaal.vibhags.length +1;
     
    
    this.vibhagStartBeat = 0;
    this.vibhagDuration = 0;
  }

  saveToStorage() {
    localStorage.setItem('taalRepo', JSON.stringify(this.taals));
  }

  loadTaals() {
    const data = localStorage.getItem('taalRepo');
    if (data) this.taals = JSON.parse(data);
  }

  saveTaal() {
    if (!this.newTaal.name || this.newTaal.numberOfBeats <= 0 || this.newTaal.vibhags.length === 0) {
      this.presentToast('Fill all Taal fields and add at least one Vibhag');
      return;
    }

    const totalVibhagBeats = this.newTaal.vibhags.reduce((s, v) => s + v.durationInBeats, 0);
    if (totalVibhagBeats > this.newTaal.numberOfBeats) {
      this.presentToast('Vibhag beats exceed Taal beat count');
      return;
    }

    if (this.editTaalIndex!=null)
    {
      if (this.taals[this.editTaalIndex])
      {
        let copyTaal={... this.newTaal};
        this.taals[this.editTaalIndex]=copyTaal;
      }
    }
    else this.taals.push({ ...this.newTaal });
    this.saveToStorage();
    this.resetForm();
  }

  deleteTaal(index: number) {
    this.taals.splice(index, 1);
    this.saveToStorage();
  }

  updateTaal(index: number) {
    let newTaal=this.taals[index];
    this.newTaal.name=newTaal.name;
    this.newTaal.numberOfBeats=newTaal.numberOfBeats;
    this.newTaal.tempoGenre=newTaal.tempoGenre;
    this.newTaal.vibhags=newTaal.vibhags;
    this.editTaalIndex=index;
    this.taalDisplay=true;
  }
  
  get filteredTaals() {
    if (!this.searchTerm) return this.taals;
    return this.taals.filter(t => t.name.toLowerCase().includes(this.searchTerm.toLowerCase()));
  }

  updateVibhag() {
    if (this.editIndex === null) return;
  
    const label = this.vibhagLabel?.trim();
    const start = parseInt(this.vibhagStartBeat.toString());
    const duration = parseInt(this.vibhagDuration.toString());
  
    if (!label) {
      this.presentToast('Vibhag label cannot be blank');
      return;
    }
  
    if (start <= 0 || duration <= 0 || !Number.isInteger(start) || !Number.isInteger(duration)) {
      this.presentToast('Start and Duration must be positive integers');
      return;
    }
  
    const newStart = start;
    const newEnd = start + duration - 1;
  
    // Check for overlap with all other vibhags except the one being edited
    const overlaps = this.newTaal.vibhags.some((v, i) => {
      if (i === this.editIndex) return false;
      const existingStart = v.startBeat;
      const existingEnd = v.startBeat + v.durationInBeats - 1;
      return !(newEnd < existingStart || newStart > existingEnd);
    });
  
    if (overlaps) {
      this.presentToast('Overlap with another vibhag');
      return;
    }
  
    if (newEnd > this.newTaal.numberOfBeats) {
      this.presentToast('Vibhag exceeds total Taal beats');
      return;
    }
  
    // Update Vibhag
    this.newTaal.vibhags[this.editIndex] = {
      ...this.newTaal.vibhags[this.editIndex],
      label,
      startBeat: start,
      durationInBeats: duration,
      markers:  this.markers?.slice() as Marker[]
    };
  
    this.editIndex = null;
    this.vibhagLabel = '';
    this.vibhagStartBeat = 0;
    this.vibhagDuration = 0;
  }
  
getVibhagLabel()
{
  if (this.editIndex!=null)
  {
    if (this.vibhagLabel)
        return this.vibhagLabel;
    else return  (this.vibhagLabel="Part "+this.editIndex+1);
  }
  else
  {
   if (!this.vibhagLabel) 
    return (this.vibhagLabel="Part "+this.newTaal.vibhags.length +1);
   return this.vibhagLabel;
  }
  return "";
}
editTaalIndex:number|null=null;
taalDisplay=false;
addTaal()
{
  this.taalDisplay=true;
  this.editTaalIndex=null;
  this.resetForm();
  this.taalDisplay=true;
  this.editIndex=null;
}
beatsChanged(ev:any)
{
  if (ev.detail && ev.detail.value)
  {
    let b=parseInt(ev.detail.value);
    if (b>0)
    {
      if (this.markers )
        if  (this.markers.length > b)
      {
        this.markers.splice(b,(b - this.markers.length));
        return;
      }
      else if (this.markers.length < b)
      {
        for (let ix=this.markers.length ; ix < b; ix++)
        {
          this.markers.push(Marker.None);
        }
        return;
      }
      // brand new 
      let ar=[];
      for (let ix=0; ix < b ; ix++)
      {
        ar.push(Marker.None);
        
      }
      this.markers=ar;
    }
  }
}
async popupMarker(index :number)
{
  const modal = await this.modalController.create({
    component: MarkerComp,
      componentProps: {
        markers: this.markers,// array of markers,
        index:index  // index to what is being operated
      }
    });
    await modal.present();
}


omanad()
{
  if (this.parser)
  {
    if (this.parser.compositionMem)
        if (this.parser.compositionMem.measures)
         return this.parser.compositionMem.measures;
      return [];
  }
  else
  return [];
}
hasmeasures()
{
  if (this.parser.compositionMem)
    if (this.parser.compositionMem.measures)
     return this.parser.compositionMem.measures.length;
return false;
}
measure_class="";
vibhagWidths:number[]=[]
cparser:any=null;
/*------------------
SaReGa Notation System
'
S R G  m P D N -> Shuddh 
r g d n -> Komal
M -> Tivra 

'-' Silence 

'~' Sustainenance of last note  - takes duration
$  Andoloan of last note - takes duration and can be stand alone, in which case preceding note in andolan

[(]->Next note is start of meend
[)]-> Previous note was last note of the meend

(k ?) - Kan Note
(m ?) - Murki note
(2 -> Each beat now is Dugun instead of single beat - until  )or '|' or '||. Can not span across phrases

(3  -> Each beat is now  Tigun )
(4 -> Each Beat is now chougun)

':'->Explicit beat Seperator
'|' -> Vibhag Seperator
'||' ->Meaasure Seperator
',' -> Break sound. No duration
';' -> Breath sound - duration as per meter

Kan ::= <Token.Kan> <Shruti> <Token.CloseBracket>;
Murki ::=<Token.Murki> <Shruti> {Shruti|Token.sustain} <Token.CloseBracket>
ComplexNote ::= [Token.MeendBegin] [Kan | Murki ] <Shruti> [kan] [TokenMeendEnd|]

BeatSequence ::= { ComlexNote| Token.silence | Token.sustain |  Token.breath| Token.BRSOUND }
Phrase= series of Beat Sequence seperated either by  Token.MEASURE  | TOKEN.SPACE | Token.VSEP 

*/
parseTest()
{
let sample =`[(S'R GM PD)]|SR N.S S- N'- |(kG)P M G|SR gM S'||
DN SR GN PM | SD NS GR GN|Pd NS RSNS GR|S' S'  S' ||
`

let myParser=this.parser;
let compNode=myParser.parse(sample);

let mem=myParser.compositionMem?.measures;
if (mem)
{
let measure= mem[0] ;
let v=measure.vibhag;
let vc=v.length;
let totalBeats=0;
v.forEach((vibhag,ix)=>{
this.vibhagWidths[ix]=vibhag.beats?.length as number;
totalBeats +=vibhag.beats?.length as number;
});

this.measure_class ="";
let margins=this.vibhagWidths.length*8;

this.vibhagWidths.map((d)=>{
  this.measure_class+=((100-margins)*d/totalBeats + 8) + '% ';
})

this.cparser=myParser.compositionParser;
}
}
language='en';
setLan(event:any)
{
  if (event.detail )
  {
    this.language=event.detail.value;
  }
}
omenaadbeatsubdata(beatdata:any)
{
  let result='';
  if (beatdata.gunChar)
    result=beatdata.gunChar;
  beatdata.subBeats.forEach ((sub:any)=>{
   
      
if (sub.preHtml) 
  result+='<sup> '+this.cparser.shrutiToOmenad(sub.preHtml,this.language)+'</sup>';
if (sub.meend) result+=sub.meend;
result+=sub.noteChar;
if (sub.postHtml)
result+='<sup>'+this.cparser.shrutiToOmenad(sub.postHtml,this.language)+'</sup>';
               
});
return this.sanitizer.bypassSecurityTrustHtml(result)
}
}
